class ReferralcandySignupForm extends HTMLElement {
    constructor() {
        super()
        this.form = this.querySelector("form");
        this.copyButton = this.querySelector("#copyButton");

        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.copyButton.addEventListener("click", this.handleCopyButtonClick.bind(this));
    }

    handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        if (formData.get("first_name") != "" && formData.get("first_name") != "" && formData.get("first_name") != "") {
            fetch("https://h2tcs394f0.execute-api.eu-central-1.amazonaws.com/dev/referralCandySignup",
                {
                    body: JSON.stringify(Object.fromEntries(formData)),
                    method: "post"
                }).then(res => res.json()).then(data => {
                    document.querySelector("#referral-link").innerHTML = data.referral_link;
                    document.querySelector(".referral-success").style.display = "block";
            });
        }

    }

    handleCopyButtonClick(e){
        e.preventDefault();
        const link = document.querySelector("#referral-link").innerText;
        navigator.clipboard.writeText(link);
        document.querySelector(".referral-copy-success").style.display = "block";
    }
}

customElements.define('referralcandy-signup-form', ReferralcandySignupForm);